import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../../Components/spinner/spinner';
import { API_BASE_URL } from '../../../config';
import { useTranslation } from 'react-i18next';

export const StaffKeyJudgementComponent = () => {
  const { t } = useTranslation();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: t('keyJudgement.slNo'), width: 70 },
    { id: 'subject', field: 'subject', headerName: t('keyJudgement.subject'), width: 250 },
    { id: 'orderNo', field: 'orderNo', headerName: t('keyJudgement.orderNo'), width: 150 },
    { id: 'orderDate', field: 'orderDate', headerName: t('keyJudgement.orderDate'), width: 150 },
    { id: 'language', field: 'language', headerName: t('keyJudgement.language'), width: 150 },
    // {
    //   id: 'links',
    //   field: 'links',
    //   headerName: t('keyJudgement.links'),
    //   width: 120,
    //   renderCell: (params) => (
    //     <a href={params.value} target="_blank" rel="noopener noreferrer">
    //       {t('keyJudgement.download')}
    //     </a>
    //   ),
    // },
    {
  id: 'links',
  field: 'links',
  headerName: t('advertisement.links'),
  width: 120,
  renderCell: (params) => {
    if (!params.value) {
      return <span>Not Found</span>;
    }
    return (
      <a href={params.value} target="_blank" rel="noopener noreferrer">
        {t('advertisement.download')}
      </a>
    );
  },
},

  ];

  useEffect(() => {
    axios.get(`${API_BASE_URL}/home-notification/key-judgement/`)
      .then(response => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          subject: item.subject,
          orderNo: item.order_no,
          orderDate: new Date(item.order_date).toLocaleDateString('en-GB').replace(/\//g, '-'),
          language: item.language,
          links: item.link,
        }));
        setRows(apiData);
        setSnackbarMessage(t('keyJudgement.successMessage'));
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch(error => {
        console.error('Failed to fetch Special Court Orders:', error);
        setSnackbarMessage(t('keyJudgement.errorMessage'));
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, [t]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box
        display="flex"
        justifyContent="center"
        backgroundColor="rgba(195, 234, 203, 0.1)"
        mb={2}
      >
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          {t('keyJudgement.heading')}
        </Typography>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus={true}
        enableSort={true}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
